import { get, post } from '@/utils/http'
import { SERVERS } from '@/constants/environment'

export const setUserExternalValue = post(`/userWrite/setExternalValue`)

export const saveUserSetting = post(`/UserWrite/saveUserSetting`)

export const fetchUserSetting = get(`/userRead/setting`)

export const fetchLastLoginInfo = get(`/userRead/lastLoginInfo`)

// 获取需sentry 行为100%采样用户
export const fetchSuggesttionSentry = get('/userRead/suggestionForSentry')

export const logout = post(`${SERVERS.LOGIN}/write/logout`)

export const fetchPlanVersion = get('/pageRead/getMainSystemId')

// 获取阿里国际站账号授权状态
export const checkIcbuUserAuth = get('/alibabaRead/checkUserAuth')

// 解绑阿里巴巴国际站账号
export const unbindIcbuAccount = get('/alibabaWrite/unbindUserAuth')

// 轮询阿里国际新账户绑定 以及 新店铺 授权状态
export const checkIcbuBindStatus = get('/alibabaRead/checkBindStatus')

// 阿里国际各账户未读数
export const fetchIcbuUsersUnread = get('/alibabaRead/unReadList')

// 阿里店铺授权状态
export const getOauthUrl = get('/alibabaRead/getOauthUrl')

// 轮询已有店铺授权状态
export const checkIcbuStoreStatus = get('/alibabaRead/storeInfo')

// 店铺解除授权
export const unbindStoreAuth = post(`/alibabaWrite/cancelStoreAuth`)

// 店铺列表
export const getStoreList = get(`/alibabaRead/storeList`)

// 获取用户设置
export const getUserSetting = get('/userRead/setting')

// 登录限制清除 登录信息
export const fetchLoginLimit = post('/account/loginLimit')
